module.exports = "/images/london-20.jpg";